document.addEventListener('mousemove', function (e) {
  var wrap = e.target.closest && e.target.closest('#ap_product_detail_media .ap-product-media-image-wrapper');
  if (!wrap) return;
  var img = wrap.querySelector('img');
  if (!img) return;
  var r = wrap.getBoundingClientRect();
  img.style.transformOrigin =
    ((e.clientX - r.left) / r.width * 100) + '% ' +
    ((e.clientY - r.top) / r.height * 100) + '%';
});